import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class AuthenticationService {

  static authenticate(username, password, secondFactor = null) {
    return axios.post(`${ROOT}auth`, { username, password, secondFactor });
  }

  static logout() {
    return axios.post(`${ROOT}users/logout`);
  }

}

export default AuthenticationService;
